<div class="tab-content">
  @if (!isLoading) {
    <div class="row tw-gap-y-6">
      @for (campaign of campaigns; track campaign) {
        <div class="col-xl-4 col-lg-6 col-md-6">
          <app-campaign-card [campaign]="campaign"></app-campaign-card>
        </div>
      }
      @if (!campaigns || campaigns.length === 0) {
        <div class="col-12 pt-5 pb-5 text-center">
          <span [innerHTML]="noRecordText | translate" (click)="processLinks($event)"></span>
        </div>
      }
    </div>
  }
  @if (isLoading) {
    <div class="tw-py-10">
      <agmo-loading></agmo-loading>
    </div>
  }
  @if (displayPagination && total > params.take) {
    <div class="row">
      <div class="col-lg-12">
        <div class="paging mt-3">
          <ngb-pagination
            [collectionSize]="total"
            [maxSize]="5"
            [rotate]="true"
            [pageSize]="params.take"
            [(page)]="params.currentPage"
            (pageChange)="getList()"
          >
            <ng-template ngbPaginationPrevious><i class="fa fa-chevron-left"></i></ng-template>
            <ng-template ngbPaginationNumber let-page>{{ page }}</ng-template>
            <ng-template ngbPaginationNext><i class="fa fa-chevron-right"></i></ng-template>
          </ngb-pagination>
        </div>
      </div>
    </div>
  }
</div>
